import { Component, OnInit, ElementRef } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../auth-service.service';
import { AuthService as TH } from "../services/auth.service";
import { EventManager } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { VariablesGlobales } from '../services/globals';
import { log } from 'util';
import { User } from '../models/user';
import { ConfigService } from '../services/config.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  public isMobile = false;
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;
  apikey: string;
  user = this.getUser();
  config = ConfigService.GetItem;
    sanitizer: any;
  public annonces: AnnonceLite[];
  public annoncesFilter: AnnonceLite[];
  constructor(private encdec: EncryptDecryptService, private http: HttpClient, private eventManager: EventManager, public auth: AuthService, private authService: TH, location: Location, private element: ElementRef, public router: Router, public param: VariablesGlobales, private _sanitizer: DomSanitizer) {
    this.location = location;
    this.sidebarVisible = false;
    this.eventManager.addGlobalEventListener('window', 'resize', this.OnResize.bind(this));
    this.apikey = localStorage.getItem('apikey');
    this.annoncesFilter = this.annonces;
    this.annonces = [];
  }
  getUser(): User {
    return JSON.parse(localStorage.getItem('currentUser')) as User;
  }
  facebook() {
    window.open(this.config('f_fb')?.txt, '_blank');
  }
  linkedin() {
    window.open(this.config('f_linkedin')?.txt, '_blank');
  }
  twitter() {
    window.open(this.config('f_twitter')?.txt, '_blank');
  }
  insta() {
    window.open(this.config('f_insta')?.txt, '_blank');
  }
  youtube() {
    window.open(this.config('f_youtu')?.txt, '_blank');
  }
  pinterest() {
    window.open(this.config('f_pinterest')?.txt, '_blank');
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
      var $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
    console.log("Annonces:", this.annonces.length);
  }

  private OnResize(event: any) {
    if (window.screen.width >= 992) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
    //this.mapComponent.resize();
  }

  ngAfterViewChecked() {
    if (window.screen.width >= 992) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
  }

  sidebarOpen() {
    var $toggle = document.getElementsByClassName('navbar-toggler')[0];
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);
    body.classList.add('nav-open');
    setTimeout(function () {
      $toggle.classList.add('toggled');
    }, 430);

    var $layer = document.createElement('div');
    $layer.setAttribute('class', 'close-layer');


    if (body.querySelectorAll('.main-panel')) {
      document.getElementsByClassName('main-panel')[0].appendChild($layer);
    } else if (body.classList.contains('off-canvas-sidebar')) {
      document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
    }

    setTimeout(function () {
      $layer.classList.add('visible');
    }, 100);

    $layer.onclick = function () { //asign a function
      body.classList.remove('nav-open');
      this.mobile_menu_visible = 0;
      this.sidebarVisible = false;

      $layer.classList.remove('visible');
      setTimeout(function () {
        $layer.remove();
        $toggle.classList.remove('toggled');
      }, 400);
    }.bind(this);

    body.classList.add('nav-open');
    this.mobile_menu_visible = 1;
    this.sidebarVisible = true;
  };
  sidebarClose() {
    var $toggle = document.getElementsByClassName('navbar-toggler')[0];
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton.classList.remove('toggled');
    var $layer = document.createElement('div');
    $layer.setAttribute('class', 'close-layer');

    this.sidebarVisible = false;
    body.classList.remove('nav-open');
    // $('html').removeClass('nav-open');
    body.classList.remove('nav-open');
    if ($layer) {
      $layer.remove();
    }

    setTimeout(function () {
      $toggle.classList.remove('toggled');
    }, 400);

    this.mobile_menu_visible = 0;
  };
  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }
  goToConnexion() {
    this.router.navigate(['auth']);
  }

  goToProfil() {
    this.router.navigate(['profil']);
  }

  GoToDeconnexion() {
    this.authService.logout();
    this.router.navigate(['auth']);
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Trouillet';
  }

  isConnected(): boolean {
    if (localStorage.getItem('currentUser')) {
      return true;
    } else {
      return false;
    }
  }
  safeCss(style) {
    return this._sanitizer.bypassSecurityTrustStyle(style);
  }
  public afficheAnnonce() {
    if (this.annonces.length > 0)
      return true;
  }
}
interface AnnonceLite {
  idannonce: number;
  intitule: string;
  emp_adresse1: string;
  emp_code_postal: string;
  emp_ville: string;
  contrats: string;
  societe_adresse: string;
  societe_cp: string;
  societe_ville: string;
  societe_logo: string;
  societe_groupe: string;
  ref: string;
  previsu: string;
  niveau_formation: string;
  regions: string;
  fonctions: string;
}
